import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import { useDispatch } from "react-redux";
import {

  createEmployeeService,
  getEmployeeService,

  updateEmployeeService,

} from "redux/services/clients_service";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const CustomerModal = ({
  isOpen,
  onClose,
  customer,
  mode, // 'view', 'edit', 'create'
  onSave,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (customer && (mode === "view" || mode === "edit")) {
      setFormData({
        first_name: customer.first_name || "",
        last_name: customer.last_name || "",
        email: customer.email || "",
        phone: customer.phone || "",
        password: "", // Do not pre-fill password for security reasons
      });
    } else if (mode === "create") {
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        password: "",
      });
    }
    setErrors({});
  }, [customer, mode, isOpen]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.first_name.trim()) {
      newErrors.first_name = "First name is required";
    }

    if (!formData.last_name.trim()) {
      newErrors.last_name = "Last name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    }

    if (mode === "create" && !formData.password.trim()) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      await onSave(formData);

      if (mode === "create") {
     
        dispatch(createEmployeeService({ ...formData, role_id: 1 })).then(
          (response) => {
            if (
              response?.payload?.status == 200 ||
              response?.payload?.status == 201
            ) {
              toast("تمت عملية الإضافة بنجاح");
              dispatch(getEmployeeService({ page: 1 }));
             // onClose();
            }else {
                    dispatch(
                      updateClientService({ id: customer?.id, formData: formData })
                    ).then((response) => {
                      if (
                        response?.payload?.status == 200 ||
                        response?.payload?.status == 201
                      ) {
                        toast("Editi !");
                        dispatch(getClientsService({ page: 1 }));
                        onClose();
                      }
                    });
                  }
          }
        );
      } else {
        dispatch(
          updateEmployeeService({ id: customer?.id, formData: formData })
        ).then((response) => {
          if (
            response?.payload?.status == 200 ||
            response?.payload?.status == 201
          ) {
            toast("تمت عملية التعديل بنجاح");
            dispatch(getEmployeeService({ page: 1 }));
            onClose();
          }else {
                  dispatch(
                    updateClientService({ id: customer?.id, formData: formData })
                  ).then((response) => {
                    if (
                      response?.payload?.status == 200 ||
                      response?.payload?.status == 201
                    ) {
                      toast("Editi !");
                      dispatch(getClientsService({ page: 1 }));
                      onClose();
                    }
                  });
                }
        });
      }
     // onClose();
    } catch (error) {
      console.error("Error saving customer:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-elevation-3 w-full max-w-2xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3 gap-2">
            <div className="w-10 h-10 bg-primary rounded-md flex items-center justify-center">
              <Icon
                name={
                  mode === "create"
                    ? "User Plus"
                    : mode === "edit"
                    ? "Edit"
                    : "User "
                }
                size={20}
                color="white"
              />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-foreground">
                {mode === "create"
                  ? "إضافة مشرف"
                  : mode === "edit"
                  ? t("تعديل معلومات مشرف")
                  : "Customer Details"}
              </h2>
              {customer && mode !== "create" && (
                <p className="text-sm text-muted-foreground">
                  ID: {customer.id}
                </p>
              )}
            </div>
          </div>
          <button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
          {mode === "view" ? (
            // View Mode
            <div className="space-y-6">
              {/* Basic Information */}
              <div>
                <h3 className="text-lg font-medium text-foreground mb-4">
                  {t("basicInformation")}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      {t("first_name")}
                    </label>
                    <p className="text-foreground font-medium">
                      {customer?.first_name}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      {t("last_name")}
                    </label>
                    <p className="text-foreground font-medium">
                      {customer?.last_name}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      Company
                    </label>
                    <p className="text-foreground">{customer?.company}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      {t("email")}
                    </label>
                    <p className="text-foreground">{customer?.email}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      {t("phone")}
                    </label>
                    <p className="text-foreground">{customer?.phone}</p>
                  </div>

                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      Last Contact
                    </label>
                    <p className="text-foreground">
                      {customer?.lastContact
                        ? formatDate(customer.lastContact)
                        : "Never"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Address Information */}
              {customer?.address && (
                <div>
                  <h3 className="text-lg font-medium text-foreground mb-4">
                    Address
                  </h3>
                  <div className="bg-surface p-4 rounded-md">
                    <p className="text-foreground">
                      {customer.address}
                      <br />
                      {customer.city}, {customer.state} {customer.zipCode}
                    </p>
                  </div>
                </div>
              )}

              {/* Notes */}
              {customer?.notes && (
                <div>
                  <h3 className="text-lg font-medium text-foreground mb-4">
                    Notes
                  </h3>
                  <div className="bg-surface p-4 rounded-md">
                    <p className="text-foreground whitespace-pre-wrap">
                      {customer.notes}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ) : (
            // Edit/Create Mode
            <div className="space-y-6">
              {/* Basic Information */}
              <div>
                <h3 className="text-lg font-medium text-foreground mb-4">
                  {t("basicInformation")}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label={t("first_name")}
                    type="text"
                    value={formData.first_name}
                    onChange={(e) =>
                      handleInputChange("first_name", e.target.value)
                    }
                    error={errors.first_name}
                    required
                    placeholder="الاسم الأول"
                  />

                  <Input
                    label={t("last_name")}
                    type="text"
                    value={formData.last_name}
                    onChange={(e) =>
                      handleInputChange("last_name", e.target.value)
                    }
                    error={errors.last_name}
                    required
                    placeholder="الكنية"
                  />

                  <Input
                    label={t("email")}
                    type="email"
                    value={formData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    error={errors.email}
                    required
                    placeholder="الإيميل"
                  />

                  <Input
                    label={t("phone")}
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => handleInputChange("phone", e.target.value)}
                    error={errors.phone}
                    required
                    placeholder="رقم الهاتف"
                  />

                  {mode === "create" && (
                    <Input
                      label="كلمة المرور"
                      type="password"
                      value={formData.password}
                      onChange={(e) =>
                        handleInputChange("password", e.target.value)
                      }
                      error={errors.password}
                      required
                      placeholder="كلمة المرور"
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border gap-6">
          {mode === "view" && (
            <Button
              variant="default"
              onClick={() => {
                /* Switch to edit mode */
              }}
            >
              <Icon name="Edit" size={16} className="mr-2" />
              {t("تعديل مشرف")}
            </Button>
          )}

          {(mode === "edit" || mode === "create") && (
            <Button variant="default" onClick={handleSave} loading={isLoading}>
              {mode === "create" ? t("إضافة ") : t("save")}
            </Button>
          )}

          <button variant="outline" onClick={onClose}>
            {mode === "view" ? t("close") : t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerModal;
